const locales = [
  {
    code: 'nl',
    language: 'nl-NL',
    storeCode: 'nl_nl',
    domain: 'https://www.dille-kamille.nl',
    file: 'nl.json',
    name: 'Nederlands',
    flag: '🇳🇱',
    numberFormats: {
      currency: {
        style: 'currency',
        currency: 'EUR',
      },
    },
    datetimeFormats: {
      default: {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      },
      short: {
        year: 'numeric',
        month: 'short',
        day: '2-digit',
      },
      long: {
        year: 'numeric',
        month: 'long',
        day: '2-digit',
        weekday: 'long',
      },
    },
  },
  {
    code: 'nl-be',
    language: 'nl-BE',
    storeCode: 'nl_be',
    domain: 'https://www.dille-kamille.be',
    file: 'nl.json',
    name: 'Nederlands (BE)',
    flag: '🇧🇪',
    numberFormats: {
      currency: {
        style: 'currency',
        currency: 'EUR',
      },
    },
    datetimeFormats: {
      default: {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      },
      short: {
        year: 'numeric',
        month: 'short',
        day: '2-digit',
      },
      long: {
        year: 'numeric',
        month: 'long',
        day: '2-digit',
        weekday: 'long',
      },
    },
  },
  {
    code: 'fr-be',
    language: 'fr-BE',
    storeCode: 'fr_be',
    domain: 'https://www.dille-kamille.be',
    file: 'fr.json',
    name: 'Français (BE)',
    flag: '🇧🇪',
    numberFormats: {
      currency: {
        style: 'currency',
        currency: 'EUR',
      },
    },
    datetimeFormats: {
      default: {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      },
      short: {
        year: 'numeric',
        month: 'short',
        day: '2-digit',
      },
      long: {
        year: 'numeric',
        month: 'long',
        day: '2-digit',
        weekday: 'long',
      },
    },
  },
  {
    code: 'fr',
    language: 'fr-FR',
    storeCode: 'fr_fr',
    domain: 'https://www.dille-kamille.fr',
    file: 'fr.json',
    name: 'Français',
    flag: '🇫🇷',
    numberFormats: {
      currency: {
        style: 'currency',
        currency: 'EUR',
      },
    },
    datetimeFormats: {
      default: {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      },
      short: {
        year: 'numeric',
        month: 'short',
        day: '2-digit',
      },
      long: {
        year: 'numeric',
        month: 'long',
        day: '2-digit',
        weekday: 'long',
      },
    },
  },
  {
    code: 'de',
    language: 'de-DE',
    storeCode: 'de_de',
    domain: 'https://www.dille-kamille.de',
    file: 'de.json',
    name: 'Deutsch',
    flag: '🇩🇪',
    numberFormats: {
      currency: {
        style: 'currency',
        currency: 'EUR',
      },
    },
    datetimeFormats: {
      default: {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      },
      short: {
        year: 'numeric',
        month: 'short',
        day: '2-digit',
      },
      long: {
        year: 'numeric',
        month: 'long',
        day: '2-digit',
        weekday: 'long',
      },
    },
  },
  {
    code: 'de-at',
    language: 'de-AT',
    storeCode: 'de_at',
    domain: 'https://www.dille-kamille.at',
    file: 'de.json',
    name: 'Deutsch (AT)',
    flag: '🇦🇹',
    numberFormats: {
      currency: {
        style: 'currency',
        currency: 'EUR',
      },
    },
    datetimeFormats: {
      default: {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      },
      short: {
        year: 'numeric',
        month: 'short',
        day: '2-digit',
      },
      long: {
        year: 'numeric',
        month: 'long',
        day: '2-digit',
        weekday: 'long',
      },
    },
  },
  {
    code: 'en',
    language: 'en-GB',
    storeCode: 'en_en',
    domain: 'https://www.dille-kamille.com',
    file: 'en.json',
    name: 'English',
    flag: '🇬🇧',
    numberFormats: {
      currency: {
        style: 'currency',
        currency: 'EUR',
      },
    },
    datetimeFormats: {
      default: {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      },
      short: {
        year: 'numeric',
        month: 'short',
        day: '2-digit',
      },
      long: {
        year: 'numeric',
        month: 'long',
        day: '2-digit',
        weekday: 'long',
      },
    },
  },
  {
    code: 'es',
    language: 'es-ES',
    storeCode: 'es_es',
    domain: 'https://www.dille-kamille.es',
    file: 'es.json',
    name: 'Español',
    flag: '🇪🇸',
    numberFormats: {
      currency: {
        style: 'currency',
        currency: 'EUR',
      },
    },
    datetimeFormats: {
      default: {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      },
      short: {
        year: 'numeric',
        month: 'short',
        day: '2-digit',
      },
      long: {
        year: 'numeric',
        month: 'long',
        day: '2-digit',
        weekday: 'long',
      },
    },
  },
]

const numberFormats: any = {}
const datetimeFormats: any = {}
locales.forEach((locale) => {
  numberFormats[locale.code] = locale.numberFormats
  datetimeFormats[locale.code] = locale.datetimeFormats
})

const hasEN = locales.some((locale) => locale.code === 'en')

export default defineI18nConfig(() => ({
  legacy: false,
  fallbackLocale: {
    'be-nl': ['nl'],
    'be-fr': ['fr'],
    'default': [(hasEN ? 'en' : locales[0].code)],
  },
  availableLocales: locales.map(locale => locale.code),
  numberFormats,
  datetimeFormats,
  missingWarn: true,
  fallbackWarn: true,
  formatFallbackMessages: true,
}))
